// @flow
import React, { Component } from "react";

import "whatwg-fetch";
import Button from "@localytics/loc-components/lib/Button";
import { connect } from "react-redux";
import { login, reset } from "./redux/actions";
import LocalyticsLogo from "./components/LocalyticsLogo";
import NotficationBanner from "./components/NotificationBanner";
import getNextParam from "./util/utils";
import "./App.scss";

type Props = {
  dispatch: Function,
  loginNotification: string,
  redirectURL: string,
  requestedRedirect: boolean,
  isPassLogin: boolean
};

type State = {
  isValidEmail: boolean,
  hasEmptyPassword: boolean
};

/* eslint-disable no-useless-escape */
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/* eslint-enable no-useless-escape */

class App extends Component<Props, State> {
  state = {
    isValidEmail: false,
    hasEmptyPassword: false
  };

  componentWillReceiveProps(nextProps) {
    const { requestedRedirect, redirectURL } = nextProps;
    if (requestedRedirect && redirectURL !== "") {
      window.location = redirectURL;
    }
  }

  submitForm: Function = event => {
    event.preventDefault();
    const { isPassLogin } = this.props;
    const { username, password = {} } = this.inputs;
    this.props.dispatch(
      login({
        username: username.value,
        ...(isPassLogin ? { password: password.value } : null),
        next: getNextParam()
      })
    );
  };

  resetForm: Function = event => {
    event.preventDefault();
    this.inputs.username.value = "";
    this.setState({
      isValidEmail: false,
      hasEmptyPassword: false
    });
    this.props.dispatch(reset());
  };

  handleEmailInput: Function = e => {
    const { isValidEmail } = this.state;
    const isValid = this.checkEmail(e.target.value);
    if (isValidEmail !== isValid) {
      this.setState({ isValidEmail: isValid });
    }
  };

  checkEmail: Function = input => EMAIL_REGEX.test(input);

  handlePasswordInput: Function = e => {
    const { isPassLogin } = this.props;
    this.setState({ hasEmptyPassword: isPassLogin && e.target.value === "" });
  };

  bindInput: Function = node => {
    if (node) {
      this.inputs[node.name] = node;
    }
  };

  inputs: Object = {};

  render() {
    const { isPassLogin } = this.props;
    const { isValidEmail, hasEmptyPassword } = this.state;
    let advanceButtonText = !isPassLogin ? "Next" : "Login";
    if (hasEmptyPassword) {
      advanceButtonText = "Reset";
    }
    return (
      <div className="LoginPage">
        <div className="LogoContainer">
          <LocalyticsLogo />
        </div>
        <div className="FormContainer">
          <form className="Form" onSubmit={this.submitForm}>
            <input
              ref={this.bindInput}
              onChange={this.handleEmailInput}
              placeholder="Email"
              type="email"
              name="username"
              id="username-input"
            />
            <input
              ref={this.bindInput}
              onChange={this.handlePasswordInput}
              placeholder="Password"
              className={isPassLogin ? "" : "hidden"}
              type="password"
              name="password"
              id="password-input"
            />
            <div className="MainButtonContainer">
              <Button
                onClick={hasEmptyPassword ? this.resetForm : this.submitForm}
                type="primary"
                id="submit-button"
                disabled={!isValidEmail}
                className={isPassLogin ? "" : "FullWidthButton"}
              >
                {advanceButtonText}
              </Button>
              {isPassLogin && (
                <Button
                  className="BlandButton ButtonWithLink"
                  id="forgot-password-button"
                >
                  <a
                    className="loc Button InnerLink"
                    href="/accounts/password/new"
                  >
                    Forgot Password?
                  </a>
                </Button>
              )}
            </div>
            <div className="FormSeparator">
              <span className="Separator" />
              <span className="SeparatorText">or</span>
              <span className="Separator" />
            </div>
            <div>
              <Button
                className="BlandButton FullWidthButton ButtonWithLink"
                id="create-new-account-button"
              >
                <a
                  className="loc Button InnerLink"
                  href="https://www.localytics.com/product-demo-signup/"
                >
                  Request a Demo
                </a>
              </Button>
            </div>
            <div>
              <a
                className="AdditionalLink ConfirmEmailLink"
                href="/accounts/confirmation/new"
              >
                Didn&#39;t receive confirmation email?
              </a>
              <a
                className="AdditionalLink PrivacyPolicyLink"
                href="http://www.localytics.com/privacy-policy/"
              >
                Privacy Policy
              </a>
            </div>
          </form>
        </div>
        <NotficationBanner notification={this.props.loginNotification} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    loginNotification,
    redirectURL = "",
    requestedRedirect,
    requestFullfilled
  } = state;
  return {
    loginNotification,
    redirectURL,
    requestedRedirect,
    requestFullfilled,
    isPassLogin: requestedRedirect && redirectURL === "" && requestFullfilled
  };
};

export default connect(mapStateToProps)(App);
